import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import snakeCase from 'lodash/snakeCase';
import SingleSelect from '@/components/common/form/SingleSelect';
import type IWaveStat from '@/constants/integrations/IWaveStat';
import IWaveScore from '../constants/IWaveScore';
import IWaveScoreEvaluation from './IWaveScoreEvaluation';

export default function IWaveSearchFilter({
  label,
  name,
}: {
  label: string;
  name: IWaveStat;
}) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={`iwave_${snakeCase(name)}`}
      render={({ field: { ref, ...field } }) => (
        <SingleSelect label={label} {...field}>
          <SingleSelect.Item value={IWaveScore.STRONG}>
            <IWaveScoreEvaluation score={IWaveScore.STRONG} />
          </SingleSelect.Item>

          <SingleSelect.Item value={IWaveScore.GOOD}>
            <IWaveScoreEvaluation score={IWaveScore.GOOD} />
          </SingleSelect.Item>

          <SingleSelect.Item value={IWaveScore.FAIR}>
            <IWaveScoreEvaluation score={IWaveScore.FAIR} />
          </SingleSelect.Item>

          <SingleSelect.Item value={IWaveScore.WEAK}>
            <IWaveScoreEvaluation score={IWaveScore.WEAK} />
          </SingleSelect.Item>
        </SingleSelect>
      )}
    />
  );
}
